// =========================================================
//  UPPY IMPORTS & GLOBAL SETUP
// =========================================================

import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";

import Uppy from "@uppy/core";
import Informer from "@uppy/informer";
import ProgressBar from "@uppy/progress-bar";
import ThumbnailGenerator from "@uppy/thumbnail-generator";

function fileUpload(fileInput, restrictions = {}) {
  const uploadGroup = fileInput.closest(".upload_grp");
  if (!uploadGroup) return;

  const previewImg = uploadGroup.querySelector(".upload_preview");
  if (!previewImg) return;

  fileInput.style.display = "none";

  const uppy = new Uppy({
    id: fileInput.id,
    autoProceed: true,
    restrictions
  })
    .use(Informer, { target: uploadGroup })
    .use(ProgressBar, {
      target: uploadGroup.querySelector(".upload_status") || uploadGroup,
      hideAfterFinish: true
    })
    .use(ThumbnailGenerator, { thumbnailWidth: 400 });

  uppy.on("thumbnail:generated", (file, preview) => {
    if (!file.type.startsWith("image/")) return;

    previewImg.src = preview;
    previewImg.alt = file.name;
  });

  uppy.on("upload-error", () => {
    const errorSpan = uploadGroup.querySelector(".upload_status_error");
    if (errorSpan) errorSpan.style.display = "inline-block";
  });

  fileInput.addEventListener("change", (event) => {
    const files = Array.from(event.target.files || []);

    // Clear existing preview when replacing file
    previewImg.src = "";

    files.forEach(file => {
      uppy.addFile({
        name: file.name,
        type: file.type,
        data: file
      });
    });
  });
}

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".upload_file").forEach(fileInput => {
    const uploadGroup = fileInput.closest(".upload_grp");
    if (!uploadGroup) return;

    if (!uploadGroup.querySelector(".upload_status")) {
      uploadGroup.insertAdjacentHTML(
        "beforeend",
        `
        <div class="upload_status" style="display:none;">
          <span class="upload_status_progress">Uploading…</span>
          <span class="upload_status_done" style="display:none;">Uploaded</span>
          <span class="upload_status_error" style="display:none;">Error</span>
        </div>
        `
      );
    }

    if (fileInput.classList.contains("upload_image")) {
      fileUpload(fileInput, {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["image/*"],
        maxFileSize: 5 * 1024 * 1024
      });
    } else if (fileInput.classList.contains("upload_pdf")) {
      fileUpload(fileInput, {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["application/pdf"]
      });
    }
  });
});